/**
 * Generated by scripts/generate-api-response-registry.mjs.
 * Do not edit manually.
 */
import type { ZodTypeAny } from "zod";
import * as adsSchemas from "./ads.zod";
import * as boards_configSchemas from "./boards-config.zod";
import * as brandsSchemas from "./brands.zod";
import * as categoriesSchemas from "./categories.zod";
import * as dashboardSchemas from "./dashboard.zod";
import * as exportsSchemas from "./exports.zod";
import * as homeSchemas from "./home.zod";
import * as jobsSchemas from "./jobs.zod";
import * as login_historySchemas from "./login_history.zod";
import * as notificationsSchemas from "./notifications.zod";
import * as ogpSchemas from "./ogp.zod";
import * as pointsSchemas from "./points.zod";
import * as postsSchemas from "./posts.zod";
import * as productsSchemas from "./products.zod";
import * as rankingsSchemas from "./rankings.zod";
import * as readsSchemas from "./reads.zod";
import * as reviewsSchemas from "./reviews.zod";
import * as searchSchemas from "./search.zod";
import * as user_registersSchemas from "./user_registers.zod";
import * as usersSchemas from "./users.zod";

interface ApiResponseSchemaEntry {
    method: string;
    pattern: RegExp;
    schemasByStatus: Record<number, ZodTypeAny>;
}

const apiResponseSchemaRegistry: ApiResponseSchemaEntry[] = [
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/brands/recommends/clear$"),
        schemasByStatus: {
            200: brandsSchemas.ClearBrandRecommends200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/media/delete$"),
        schemasByStatus: {
            200: postsSchemas.DeleteMedia200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/users/favorites/[^/]+/remove$"),
        schemasByStatus: {
            200: usersSchemas.RemoveFavorite200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/products/[^/]+/recommends$"),
        schemasByStatus: {
            200: productsSchemas.RemoveProductRecommend200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/brands/[^/]+/recommends$"),
        schemasByStatus: {
            200: brandsSchemas.RemoveBrandRecommend200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/users/recommends/[^/]+$"),
        schemasByStatus: {
            200: usersSchemas.RemoveUserRecommend200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/products/[^/]+/likes$"),
        schemasByStatus: {
            200: productsSchemas.RemoveLike200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/users/follow/[^/]+$"),
        schemasByStatus: {
            200: usersSchemas.UnfollowUser200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/attachments/[^/]+$"),
        schemasByStatus: {
            200: postsSchemas.DeleteAttachment200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/products/[^/]+$"),
        schemasByStatus: {
            200: productsSchemas.DeleteItem200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/brands/[^/]+$"),
        schemasByStatus: {
            200: brandsSchemas.DeleteItem200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/users/[^/]+$"),
        schemasByStatus: {
            200: usersSchemas.DeleteItem200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/ads/[^/]+$"),
        schemasByStatus: {
            200: adsSchemas.DeleteItem200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/recommends$"),
        schemasByStatus: {
            200: postsSchemas.RemoveRecommendForPost200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/likes$"),
        schemasByStatus: {
            200: postsSchemas.RemoveLikeFromPost200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+$"),
        schemasByStatus: {
            200: postsSchemas.DeleteBoardPost200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/comments/[^/]+/likes$"),
        schemasByStatus: {
            200: postsSchemas.RemoveLikeFromComment200Response,
        },
    },
    {
        method: "DELETE",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/comments/[^/]+$"),
        schemasByStatus: {
            200: postsSchemas.DeleteComment200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/reviews/configs/with-questions$"),
        schemasByStatus: {
            200: reviewsSchemas.GetReviewConfigsWithQuestions200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/users/password/reminder/exists$"),
        schemasByStatus: {
            200: usersSchemas.ExistsUserByEmail200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/notifications/unread-count$"),
        schemasByStatus: {
            200: notificationsSchemas.GetUnreadCount200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/rankings/bulk/products$"),
        schemasByStatus: {
            200: rankingsSchemas.GetBulkProductRankings200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/products/image-status$"),
        schemasByStatus: {
            200: productsSchemas.GetImageStatus200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/user-registers/verify$"),
        schemasByStatus: {
            200: user_registersSchemas.VerifyUserRegistrationToken200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/users/address/lookup$"),
        schemasByStatus: {
            200: usersSchemas.LookupAddressByPostalCode200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/rankings/bulk/users$"),
        schemasByStatus: {
            200: rankingsSchemas.GetBulkUserRankings200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/search/suggestions$"),
        schemasByStatus: {
            200: searchSchemas.GetSearchSuggestions200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/rankings/configs$"),
        schemasByStatus: {
            200: rankingsSchemas.GetRankingConfigs200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/admin/dashboard$"),
        schemasByStatus: {
            200: dashboardSchemas.GetDashboardStats200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/reviews/configs$"),
        schemasByStatus: {
            200: reviewsSchemas.GetReviewConfigs200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/boards-config$"),
        schemasByStatus: {
            200: boards_configSchemas.GetBoardsConfig200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/notifications$"),
        schemasByStatus: {
            200: notificationsSchemas.GetNotifications200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/search/menu$"),
        schemasByStatus: {
            200: searchSchemas.GetSearchMenu200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/categories$"),
        schemasByStatus: {
            200: categoriesSchemas.GetCategories200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/products$"),
        schemasByStatus: {
            200: productsSchemas.GetItems200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/rankings$"),
        schemasByStatus: {
            200: rankingsSchemas.GetRankings200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/brands$"),
        schemasByStatus: {
            200: brandsSchemas.GetBrands200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/users$"),
        schemasByStatus: {
            200: usersSchemas.GetItems200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/home$"),
        schemasByStatus: {
            200: homeSchemas.GetHomeData200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/jobs$"),
        schemasByStatus: {
            200: jobsSchemas.GetJobs200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/ads$"),
        schemasByStatus: {
            200: adsSchemas.GetAds200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/brands/[^/]+/placeholder-product$"),
        schemasByStatus: {
            200: brandsSchemas.GetBrandPlaceholderProduct200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/products/[^/]+/merge-candidates$"),
        schemasByStatus: {
            200: productsSchemas.GetProductMergeCandidates200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/reviews/configs/[^/]+/questions$"),
        schemasByStatus: {
            200: reviewsSchemas.GetReviewQuestions200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/brands/[^/]+/merge-candidates$"),
        schemasByStatus: {
            200: brandsSchemas.GetBrandMergeCandidates200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/users/[^/]+/point-histories$"),
        schemasByStatus: {
            200: pointsSchemas.GetPointHistories200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/products/[^/]+/recommends$"),
        schemasByStatus: {
            200: productsSchemas.GetProductRecommendMeta200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/login-history/user/[^/]+$"),
        schemasByStatus: {
            200: login_historySchemas.GetHistoryByUser200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/brands/[^/]+/recommends$"),
        schemasByStatus: {
            200: brandsSchemas.GetBrandRecommendMeta200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/users/followings/[^/]+$"),
        schemasByStatus: {
            200: usersSchemas.GetFollowings200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/users/recommends/[^/]+$"),
        schemasByStatus: {
            200: usersSchemas.GetUserRecommendMeta200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/reviews/configs/[^/]+$"),
        schemasByStatus: {
            200: reviewsSchemas.GetReviewConfig200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/users/favorites/[^/]+$"),
        schemasByStatus: {
            200: usersSchemas.GetFavorites200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/users/followers/[^/]+$"),
        schemasByStatus: {
            200: usersSchemas.GetFollowers200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/exports/[^/]+/status$"),
        schemasByStatus: {
            200: exportsSchemas.GetExportStatus200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/boards-config/[^/]+$"),
        schemasByStatus: {
            200: boards_configSchemas.GetBoardConfig200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/users/posts/[^/]+$"),
        schemasByStatus: {
            200: usersSchemas.GetUserPosts200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/categories/[^/]+$"),
        schemasByStatus: {
            200: categoriesSchemas.GetCategoryById200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/products/[^/]+$"),
        schemasByStatus: {
            200: productsSchemas.GetItem200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/brands/[^/]+$"),
        schemasByStatus: {
            200: brandsSchemas.GetItem200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/posts/[^/]+$"),
        schemasByStatus: {
            200: postsSchemas.GetBoardList200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/users/[^/]+$"),
        schemasByStatus: {
            200: usersSchemas.GetItem200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/reviews/configs/[^/]+/questions/[^/]+$"),
        schemasByStatus: {
            200: reviewsSchemas.GetReviewQuestion200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/recommends$"),
        schemasByStatus: {
            200: postsSchemas.GetRecommendMetaForPost200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/comments$"),
        schemasByStatus: {
            200: postsSchemas.GetCommentsForPost200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/reviews/[^/]+/[^/]+/answer$"),
        schemasByStatus: {
            200: reviewsSchemas.GetReviewAnswer200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/likes$"),
        schemasByStatus: {
            200: postsSchemas.GetLikesForPost200Response,
        },
    },
    {
        method: "GET",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+$"),
        schemasByStatus: {
            200: postsSchemas.GetPostDetail200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/search/history/hierarchical$"),
        schemasByStatus: {
            201: searchSchemas.SaveHierarchicalSearchHistory201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/users/social-handle-check$"),
        schemasByStatus: {
            200: usersSchemas.CheckSocialHandle200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/users/password/reminder$"),
        schemasByStatus: {
            200: usersSchemas.IssueTemporaryPasswordByEmail200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/notifications/read-all$"),
        schemasByStatus: {
            200: notificationsSchemas.MarkAllNotificationsAsRead200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/users/admin/account$"),
        schemasByStatus: {
            201: usersSchemas.CreateAdminAccount201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/ogp/fetch-image$"),
        schemasByStatus: {
            200: ogpSchemas.FetchOgpImage200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/reviews/configs$"),
        schemasByStatus: {
            201: reviewsSchemas.CreateReviewConfig201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/users/favorites$"),
        schemasByStatus: {
            200: usersSchemas.AddFavorite200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/search/history$"),
        schemasByStatus: {
            201: searchSchemas.SaveSearchHistory201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/user-registers$"),
        schemasByStatus: {
            201: user_registersSchemas.CreateUserPreRegistration201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/login-history$"),
        schemasByStatus: {
            201: login_historySchemas.SaveLoginHistory201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/media/upload$"),
        schemasByStatus: {
            201: postsSchemas.UploadMedia201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/users/avatar$"),
        schemasByStatus: {
            200: usersSchemas.UploadAvatar200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/users/follow$"),
        schemasByStatus: {
            200: usersSchemas.FollowUser200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/attachments$"),
        schemasByStatus: {
            201: postsSchemas.UploadAttachment201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/ogp/fetch$"),
        schemasByStatus: {
            200: ogpSchemas.FetchOgp200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/products$"),
        schemasByStatus: {
            201: productsSchemas.CreateItem201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/brands$"),
        schemasByStatus: {
            201: brandsSchemas.CreateItem201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/users$"),
        schemasByStatus: {
            201: usersSchemas.CreateItem201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/ads$"),
        schemasByStatus: {
            201: adsSchemas.CreateItem201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/users/point-histories/[^/]+/invalidate$"),
        schemasByStatus: {
            200: pointsSchemas.InvalidatePointHistory200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/reviews/configs/[^/]+/questions$"),
        schemasByStatus: {
            201: reviewsSchemas.CreateReviewQuestion201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/users/[^/]+/point-adjustments$"),
        schemasByStatus: {
            200: pointsSchemas.AdjustUserPoints200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/products/[^/]+/recommends$"),
        schemasByStatus: {
            200: productsSchemas.UpsertProductRecommend200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/notifications/[^/]+/read$"),
        schemasByStatus: {
            200: notificationsSchemas.MarkNotificationAsRead200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/brands/[^/]+/recommends$"),
        schemasByStatus: {
            200: brandsSchemas.UpsertBrandRecommend200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/exports/[^/]+/generate$"),
        schemasByStatus: {
            200: exportsSchemas.GenerateExport200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/users/recommends/[^/]+$"),
        schemasByStatus: {
            200: usersSchemas.UpsertUserRecommend200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/products/[^/]+/image$"),
        schemasByStatus: {
            200: productsSchemas.UploadImage200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/products/[^/]+/likes$"),
        schemasByStatus: {
            201: productsSchemas.AddLike201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/products/[^/]+/merge$"),
        schemasByStatus: {
            200: productsSchemas.MergeProduct200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/brands/[^/]+/image$"),
        schemasByStatus: {
            200: brandsSchemas.UploadBrandImage200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/brands/[^/]+/merge$"),
        schemasByStatus: {
            200: brandsSchemas.MergeBrand200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/jobs/[^/]+/abort$"),
        schemasByStatus: {
            200: jobsSchemas.AbortJob200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/ads/[^/]+/image$"),
        schemasByStatus: {
            200: adsSchemas.UploadImage200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/jobs/[^/]+/run$"),
        schemasByStatus: {
            200: jobsSchemas.RunJob200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/posts/[^/]+$"),
        schemasByStatus: {
            201: postsSchemas.CreateBoardPost201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/recommends$"),
        schemasByStatus: {
            200: postsSchemas.UpsertRecommendForPost200Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/comments$"),
        schemasByStatus: {
            201: postsSchemas.AddCommentToPost201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/reviews/[^/]+/[^/]+/answer$"),
        schemasByStatus: {
            201: reviewsSchemas.CreateReviewAnswer201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/likes$"),
        schemasByStatus: {
            201: postsSchemas.AddLikeToPost201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/reads$"),
        schemasByStatus: {
            201: readsSchemas.AddReadToPost201Response,
        },
    },
    {
        method: "POST",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/comments/[^/]+/likes$"),
        schemasByStatus: {
            201: postsSchemas.AddLikeToComment201Response,
        },
    },
    {
        method: "PUT",
        pattern: new RegExp("^/api/v1/reviews/configs/[^/]+$"),
        schemasByStatus: {
            200: reviewsSchemas.UpdateReviewConfig200Response,
        },
    },
    {
        method: "PUT",
        pattern: new RegExp("^/api/v1/users/password/[^/]+$"),
        schemasByStatus: {
            200: usersSchemas.UpdatePassword200Response,
        },
    },
    {
        method: "PUT",
        pattern: new RegExp("^/api/v1/products/[^/]+$"),
        schemasByStatus: {
            200: productsSchemas.UpdateItem200Response,
        },
    },
    {
        method: "PUT",
        pattern: new RegExp("^/api/v1/brands/[^/]+$"),
        schemasByStatus: {
            200: brandsSchemas.UpdateItem200Response,
        },
    },
    {
        method: "PUT",
        pattern: new RegExp("^/api/v1/users/[^/]+$"),
        schemasByStatus: {
            200: usersSchemas.UpdateItem200Response,
        },
    },
    {
        method: "PUT",
        pattern: new RegExp("^/api/v1/jobs/[^/]+$"),
        schemasByStatus: {
            200: jobsSchemas.UpdateJob200Response,
        },
    },
    {
        method: "PUT",
        pattern: new RegExp("^/api/v1/reviews/configs/[^/]+/questions/[^/]+$"),
        schemasByStatus: {
            200: reviewsSchemas.UpdateReviewQuestion200Response,
        },
    },
    {
        method: "PUT",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+$"),
        schemasByStatus: {
            200: postsSchemas.UpdateBoardPost200Response,
        },
    },
    {
        method: "PUT",
        pattern: new RegExp("^/api/v1/posts/[^/]+/[^/]+/comments/[^/]+$"),
        schemasByStatus: {
            200: postsSchemas.UpdateComment200Response,
        },
    },
];

export function getApiResponseSchema(method: string, pathname: string, status: number): ZodTypeAny | null {
    const normalizedMethod = method.toUpperCase();
    for (const entry of apiResponseSchemaRegistry) {
        if (entry.method !== normalizedMethod) {
            continue;
        }

        if (!entry.pattern.test(pathname)) {
            continue;
        }

        return entry.schemasByStatus[status] ?? null;
    }

    return null;
}
